import { useContext } from 'react'
import styled from 'styled-components'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/modalProvider'

import { AlignCenterItem } from '../../../components/common'
import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

import AppleIcon from '../../../assets/logo/sns/apple/apple_40@3x.png'
import GoogleIcon from '../../../assets/logo/sns/google/google_40@3x.png'
import KakaoIcon from '../../../assets/logo/sns/kakao/kakao_40@3x.png'
import NaverIcon from '../../../assets/logo/sns/naver/naver_40@3x.png'
import Yes24Icon from '../../../assets/logo/sns/yes24/yes24_40@3x.png'

interface IdentifyInfo {
  errorDescription: string
  provider: 'apple' | 'google' | 'kakao' | 'naver' | 'yes24'
  userId: number
  danalName?: string
  email?: string
}

interface AlreadyVerificationModalProps {
  info: IdentifyInfo
}

function converSnsIcon(provider: IdentifyInfo['provider']) {
  switch (provider) {
    case 'apple':
      return <SnsImage src={AppleIcon} alt="Apple Logo" />
    case 'google':
      return <SnsImage src={GoogleIcon} alt="Google Logo" />
    case 'kakao':
      return <SnsImage src={KakaoIcon} alt="Kakao Logo" />
    case 'naver':
      return <SnsImage src={NaverIcon} alt="Naver Logo" />
    case 'yes24':
      return <SnsImage src={Yes24Icon} alt="Yes24 Logo" />
    default:
      return <></>
  }
}

export function AlreadyVerificationModal({ info: { provider, email, danalName } }: AlreadyVerificationModalProps) {
  const { closeModal } = useContext(ModalContext)

  const close = () => closeModal(MODALS_ID.ALREADY_VERIFICATION)

  return (
    <Modal id={MODALS_ID.ALREADY_VERIFICATION}>
      <Content>
        <Text size={16} weight={500} block={true} $textAlign="center">
          이미 본인 인증을 완료한 계정이 있어요.
        </Text>
        <AlignCenterItem $gap={16}>
          {converSnsIcon(provider)}
          {email || danalName || ''}
        </AlignCenterItem>
      </Content>
      <Modal.Footer>
        <Button onClick={close}>확인</Button>
      </Modal.Footer>
    </Modal>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

const SnsImage = styled.img`
  width: 40px;
  height: 40px;
`

export type { IdentifyInfo }
